import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../api/BackendApi.jsx';
import { AuthLayout, FormInput, FormButton, FormError } from '../../components/AuthComponents.jsx';
import { CheckCircle } from 'lucide-react';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!uid || !token) {
      setError('Neplatný nebo expirovaný odkaz pro obnovu hesla. Zkuste to prosím znovu.');
    }
  }, [uid, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!password || !confirmPassword) {
      setError('Vyplňte obě pole.');
      return;
    }
    if (password.length < 8) {
      setError('Heslo musí mít alespoň 8 znaků.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Hesla se nseshodují.');
      return;
    }
    if (!uid || !token) {
      setError('Nepalatný odkaz.');
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword({
        uid,
        token,
        new_password: password,
        confirm_password: confirmPassword
      });
      setSuccess(response.message || 'Password has been reset successfully. You can now login.');
    } catch (err) {
      setError(err.message || 'An unknown error occurred.');
    } finally {
      setLoading(false);
    }
  };

  // Show success message
  if (success) {
    return (
      <AuthLayout title="Heslo bylo úspěšně změněno">
        <div className="text-center">
          <CheckCircle className="w-12 h-12 mx-auto text-green-600" />
          <p className="mt-4 text-lg font-medium text-gray-800">
            Nyní se můžete přihlásit
          </p>
          <button
            onClick={() => navigate('/login')}
            className="w-full justify-center flex px-4 py-2 mt-6 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Přihlásit se
          </button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Nastavení nového hesla">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <FormInput
          id="password"
          type="password"
          label="Nové heslo"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading || !uid}
          required
        />
        <FormInput
          id="confirm-password"
          type="password"
          label="Zopakujte nové heslo"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={loading || !uid}
          required
        />
        
        {error && <FormError message={error} />}

        <FormButton type="submit" loading={loading} disabled={!uid}>
          {loading ? 'Resetting...' : 'Nastavit nové heslo'}
        </FormButton>
      </form>
    </AuthLayout>
  );
};

export default ResetPasswordPage;